import React, { useEffect, useState } from 'react';
import './Catalog.css';
import ProductCard from './components/ProductCard.jsx';
import FilterSidebar from './components/FilterSidebar.jsx';
import { Link } from 'react-router-dom';
import authFetch from '../../utils/authFetch';

const Catalog = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [categories, setCategories] = useState([{ id: 'all', name: 'All Books' }]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');
  const [language, setLanguage] = useState('');
  const [level, setLevel] = useState('');
  const [role, setRole] = useState({ isAdmin: false, isPublisher: false, status: null });

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const res = await fetch('/api/store/categories');
        const json = await res.json();
        if (json?.categories) {
          const cats = [{ id: 'all', name: 'All Books' }, ...json.categories.map(c => ({ id: c.slug, name: c.name }))];
          setCategories(cats);
        }
      } catch {}
    };
    loadCategories();
  }, []);

  useEffect(() => {
    const loadRole = async () => {
      try {
        const res = await authFetch('/api/store/publisher/me/role');
        const json = await res.json();
        if (json) setRole(json);
      } catch {}
    };
    loadRole();
  }, []);

  useEffect(() => {
    const loadProducts = async () => {
      setLoading(true);
      setError(null);
      try {
        const qs = new URLSearchParams();
        if (activeCategory && activeCategory !== 'all') qs.set('category', activeCategory);
        if (language) qs.set('language', language);
        if (level) qs.set('level', level);
        const res = await fetch(`/api/store/products${qs.toString() ? `?${qs.toString()}` : ''}`);
        const json = await res.json();
        let list = json?.products || [];
        // client-side title search filter
        if (search.trim()) {
          const term = search.trim().toLowerCase();
          list = list.filter(p => (p.title||'').toLowerCase().includes(term));
        }
        setProducts(list);
      } catch (e) {
        setError('Failed to load products');
      } finally {
        setLoading(false);
      }
    };
    loadProducts();
  }, [activeCategory, language, level, search]);

  return (
    <div className="ebookstore-section">
      <div className="ebookstore-panel page-panel">
        <h1>Language Learning eBookstore</h1>
        <p className="section-description">Find the perfect digital resources to complement your language learning journey.</p>
        <div className="ebookstore-layout">
          <FilterSidebar
            categories={categories}
            activeCategory={activeCategory}
            onCategoryChange={setActiveCategory}
            language={language}
            onLanguageChange={setLanguage}
            level={level}
            onLevelChange={setLevel}
            search={search}
            onSearchChange={setSearch}
          />
          <div className="books-grid-container">
            <div className="books-header">
              <h2>{categories.find(c => c.id === activeCategory)?.name || 'All Books'}</h2>
              <div className="header-ctas">
                {role.isAdmin && (
                  <Link className="btn-header" to="/app/eBookstore/admin/submissions">Admin Submissions</Link>
                )}
                {role.isPublisher ? (
                  <Link className="btn-header" to="/app/eBookstore/publisher/dashboard">Publisher Dashboard</Link>
                ) : (
                  <Link className="btn-header accent" to="/app/eBookstore/publisher/onboarding">Become a Publisher</Link>
                )}
              </div>
            </div>
            <div className="books-grid">
              {loading && <div className="loading">Loading...</div>}
              {error && <div className="error">{error}</div>}
              {!loading && !error && products.length === 0 && <div className="empty">No products found.</div>}
              {!loading && !error && products.map(p => (
                <ProductCard key={p.id} product={p} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Catalog;
